import React, { useEffect, useState } from "react";
import CopyRight from "../../../../components/CopyRight";
import GetForm from "../GetForm";
import { IoIosArrowDown } from "react-icons/io";
import Plans from "../../Plans/Plans";
import Subscriptions from "../../Subscriptions/Subscriptions";

export default function GetFormSidebar({ menu }: { menu: boolean }) {
  const [activeTab, setActiveTab] = useState<number>(1);
  const [autoDebitTab, setAutoDebitTab] = useState<boolean>(false);
  const [autoDebitActiveTab, setAutoDebitActiveTab] = useState<number>(21);

  useEffect(() => {
    const storedActiveTab = localStorage.getItem("getForm_activeTab");
    const storedAutoDebitTab = localStorage.getItem("getForm_autoDebitTab");
    const storedAutoDebitActiveTab = localStorage.getItem(
      "getForm_autoDebitActiveTab"
    );

    if (storedActiveTab) setActiveTab(Number(storedActiveTab));
    if (storedAutoDebitTab) setAutoDebitTab(storedAutoDebitTab === "true");
    if (storedAutoDebitActiveTab)
      setAutoDebitActiveTab(Number(storedAutoDebitActiveTab));
  }, []);

  useEffect(() => {
    localStorage.setItem("getForm_activeTab", String(activeTab));
    localStorage.setItem("getForm_autoDebitTab", String(autoDebitTab));
    localStorage.setItem(
      "getForm_autoDebitActiveTab",
      String(autoDebitActiveTab)
    );
  }, [activeTab, autoDebitTab, autoDebitActiveTab]);

  return (
    <div className="flex flex-col min-h-screen -mt-20 pt-20">
      <div className="flex">
        <div
          className={
            "transition-transform duration-200 overflow-hidden fixed top-10 shrink-0 pt-10 " +
            (menu ? "translate-x-0 w-56" : "-translate-x-[100%] w-0")
          }
        >
          <div className="flex flex-col">
            <button
              onClick={() => {
                setActiveTab(1);
                setAutoDebitTab(false);
                setAutoDebitActiveTab(21);
              }}
              className={activeTab === 1 ? activeBtn : inactiveBtn}
            >
              Payment Forms
            </button>

            <div
              className={
                "cursor-pointer relative flex pr-4 items-center " +
                (activeTab === 12
                  ? "bg-[#6687FF33] font-semibold rounded-lg text-[14px] text-[#1B163B]"
                  : "font-semibold rounded-lg text-[14px] text-[#717171]")
              }
            >
              <span
                className="pl-[2.5rem] w-full py-1.5"
                onClick={() => {
                  setActiveTab(12);
                  setAutoDebitTab((prev) => !prev);
                }}
              >
                Auto Debit
              </span>

              <IoIosArrowDown
                className={
                  "text-lg duration-200 transition-transform" +
                  (autoDebitTab ? " rotate-0" : " -rotate-180")
                }
              />
            </div>

            {autoDebitTab && (
              <div className="flex flex-col w-full">
                <button
                  onClick={() => {
                    setActiveTab(12);
                    setAutoDebitActiveTab(21);
                  }}
                  className={
                    autoDebitActiveTab === 21 ? subActiveBtn : subInactiveBtn
                  }
                >
                  Subscriptions
                </button>

                <button
                  onClick={() => {
                    setActiveTab(12);
                    setAutoDebitActiveTab(20);
                  }}
                  className={
                    autoDebitActiveTab === 20 ? subActiveBtn : subInactiveBtn
                  }
                >
                  Plans
                </button>
              </div>
            )}
          </div>
        </div>

        <div
          className={
            "tab-content w-full lg:pr-8 pr-4 ml-4 " + (menu ? "pl-56" : "")
          }
        >
          {activeTab === 1 && <GetForm />}
          {activeTab === 12 && autoDebitActiveTab === 20 && <Plans />}
          {activeTab === 12 && autoDebitActiveTab === 21 && <Subscriptions />}
        </div>
      </div>

      <div className="mt-auto py-2">
        <CopyRight />
      </div>
    </div>
  );
}

const activeBtn =
  "bg-[#6687FF33] py-1.5 font-semibold rounded-lg text-[14px] text-left pl-10 text-[#1B163B]";
const inactiveBtn =
  "py-1.5 font-semibold rounded-lg text-[14px] text-left pl-10 text-[#717171]";
const subActiveBtn =
  "bg-[#6687FF33] py-1.5 font-semibold rounded-lg text-[14px] text-left pl-14 text-[#1B163B] mt-1";
const subInactiveBtn =
  "py-1.5 font-semibold rounded-lg text-[14px] text-left pl-14 text-[#717171] mt-1";
